import { Injectable, inject } from "@angular/core";
import { catchError, Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import {
  ISetting,
  SettingEnum,
  SettingNoneParsedTypes,
} from "@dmms/shared/data-access/administration/models/administration";
import { AdministrationApiService } from "@dmms/shared/data-access/administration/services/administration-api.service";
import { IApiResponse } from "@models/http/http-options";

@Injectable({
  providedIn: "root",
})
export class SettingsService {
  private administrationApiService = inject(AdministrationApiService);
  private version = 1;

  getSettingByKey(
    key: SettingEnum | string,
    defaultValue: any = null,
    version = this.version,
  ): Observable<any> {
    return this.administrationApiService.getSettingByKey(key, version).pipe(
      catchError(() => of(null)),
      map((response) => {
        return this.parseValue(response?.value, defaultValue);
      }),
    );
  }

  getSettingByKeyWithoutMapping(
    key: SettingEnum | string,
    version = this.version,
  ): Observable<IApiResponse<ISetting>> {
    return this.administrationApiService.getSettingByKey(key, version);
  }

  setSetting(
    setting: Partial<ISetting>,
    version = this.version,
  ): Observable<IApiResponse<string>> {
    return this.administrationApiService.setSetting(setting, version);
  }

  updateSetting(
    setting: Partial<ISetting>,
    version = this.version,
  ): Observable<any> {
    return this.administrationApiService.updateSetting(setting, version);
  }

  parseValue(setting: ISetting, defaultValue: any = null): any {
    const noneParse = SettingNoneParsedTypes.includes(setting?.dataType);

    return setting?.value
      ? noneParse
        ? setting.value
        : JSON.parse(setting.value)
      : defaultValue;
  }
}
